<template>
    <div class="agb">
        <ruth-header :tickets="false"></ruth-header>

        <div id="container" class="nobackgroundimg">
            <div id="content">
                <h1 class="ticketsheading">AGB</h1>

                <div class="text-box">
                    <h2>1. Geltungsbereich</h2>
                    Für alle Bestellungen über unseren Online-Ticketshop gelten die nachfolgenden AGB.<br><br>

                    <h2>2. Vertragspartner, Vertragsschluss</h2>
                    Der Kaufvertrag kommt zustande mit dem Verein "KISI – God's singing kids".<br><br>

                    <h2>3. Eintrittskarten</h2>
                    Für gelöste Karten wird kein Geld zurückerstattet. Eintrittskarten laut Preisinfo. Durch den Erwerb dieser Karte unterwirft sich der Besucher der Hausordnung. Im Falle der Absage einer Veranstaltung kann die Karte innerhalb eines Monats ab Veranstaltungsdatum rückgelöst werden. Ein darüber hinausgehender Schadensersatz ist ausgeschlossen.<br>
                    Besetzungsänderungen sind kein Grund für eine Rückvergütung des Kartenpreises<br><br>

                    <h2>4. Rückgaberecht</h2>
                    Eine Rückgabe bei bestellten Karten ist (vorbehaltlich einer möglichen Kulanzregelung) ausgeschlossen!<br>
                    Darunter sind auch laufend wiederkehrende Bestellungen (Stammkundenbelieferung) gemeint, auch wenn diese Bestellungen per webshop, eMail, Fax oder über das Telefon erfolgen. Eine Rückerstattung der Kosten für die erworbenen Karten ist darüber hinaus nicht möglich, wenn die Veranstaltung – aus welchen Gründen auch immer – nicht besucht werden kann / konnte. Eine Rückgabe von Karten nach der Veranstaltung ist ebenfalls nicht möglich.<br><br>

                    <h2>5. Bezahlung</h2>
                    In unserem Shop stehen Ihnen die folgenden Zahlungsarten zur Verfügung:<br><br>

                    <span class="highlight">SOFORT Überweisung</span><br>
                    Wir bieten SOFORT Überweisung an. Dabei erhalten wir die Überweisungsgutschrift unmittelbar. Hierdurch beschleunigt sich der gesamte Bestellvorgang. Sie benötigen hierfür lediglich Kontonummer, Bankleitzahl, PIN und TAN. Über das gesicherte, für Händler nicht zugängliche Zahlformular der SOFORT GmbH stellt SOFORT Überweisung automatisiert und in Echtzeit eine Überweisung in Ihrem Online-Bankkonto ein. Der Kaufbetrag wird dabei sofort und direkt an das Bankkonto des Händlers überwiesen. Bei Wahl der Zahlungsart SOFORT Überweisung öffnet sich am Ende des Bestellvorgangs ein vorausgefülltes Formular. Dieses enthält bereits unsere Bankverbindung. Darüber hinaus werden in dem Formular bereits der Überweisungsbetrag und der Verwendungszweck angezeigt. Sie müssen nun das Land auswählen, in dem Sie Ihr Online-Banking-Konto haben und die Bankleitzahl eingeben. Dann geben Sie die gleichen Daten, wie bei Anmeldung zum Online-Banking ein (Kontonummer und PIN). Bestätigen Sie Ihre Bestellung durch Eingabe der TAN. Direkt im Anschluss erhalten Sie die Transaktion bestätigt. Grundsätzlich kann jeder Internetnutzer die SOFORT Überweisung als Zahlungsart nutzen, wenn er über ein freigeschaltetes Online-Banking-Konto mit PIN/TAN-Verfahren verfügt. Bitte beachten Sie, dass bei einigen wenigen Banken die SOFORT Überweisung noch nicht verfügbar ist. Nähere Informationen, ob Ihre Bank diesen Dienst unterstützt erhalten Sie <a href="https://www.sofort.com/ger-DE/general/fuer-kaeufer/fragen-und-antworten/">hier</a><br><br>

                    <span class="highlight">Kreditkarte</span><br><br>

                    <span class="highlight">PayPal</span><br><br>

                    <h2>6. Eigentumsvorbehalt</h2>
                    Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.

                    <h2>7. Haftung</h2>
                    Für Ansprüche aufgrund von Schäden, die durch uns, unsere gesetzlichen Vertreter oder Erfüllungsgehilfen verursacht wurden, haften wir stets unbeschränkt<br>

                    <ul>
                        <li>bei Verletzung des Lebens, des Körpers oder der Gesundheit</li>
                        <li>bei vorsätzlicher oder grob fahrlässiger Pflichtverletzung</li>
                        <li>bei Garantieversprechen, soweit vereinbart</li>
                        <li>soweit der Anwendungsbereich des Produkthaftungsgesetzes eröffnet ist.</li>
                    </ul>
                    Bei Verletzung wesentlicher Vertragspflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren Einhaltung der Vertragspartner regelmäßig vertrauen darf (Kardinalpflichten) durch leichte Fahrlässigkeit von uns, unseren gesetzlichen Vertretern oder Erfüllungsgehilfen ist die Haftung der Höhe nach auf den bei Vertragsschluss vorhersehbaren Schaden begrenzt, mit dessen Entstehung typischerweise gerechnet werden muss.<br>

                    Im Übrigen sind Ansprüche auf Schadensersatz ausgeschlossen.
                </div>
            </div>
            <social-media></social-media>
            <ruth-footer></ruth-footer>
        </div>
    </div>
</template>

<script>
    import ruthHeader from './GlobalSegments/Header'
    import socialMedia from './GlobalSegments/SocialMedia'
    import ruthFooter from './GlobalSegments/Footer'

    export default {
        name: 'AGB',
        components: {
            ruthHeader,
            socialMedia,
            ruthFooter
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Agb.vue